import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';

// Servicios
import { CalendarService } from '../../configuration/calendar/calendar.service';
import { ReportsService } from "../reports.service";
import { SettingsService } from '../../../core/settings/settings.service';
import { AdjustService } from '../../inventory/adjust/adjust.service';
import { GlobalFunctionsService } from '../../common/functions/global-functions.service';

// Modelos
import { UserLogin } from '../../common/models/UserLogin.Model';

@Component({
  selector: 'app-report-cut',
  templateUrl: './report-cut.component.html',
  styleUrls: ['./report-cut.component.scss'],
  providers: [DatePipe]
})
export class ReportCutComponent implements OnInit {

  public userLogin: UserLogin;
  public type: number = 0;
  public typeLevel: string = '';
  public maxDate: string;
  
  // Fechas (ahora strings provenientes del datepicker)
  public CalendarDesde: string = "";
  public CalendarHasta: string = "";
  public isValidRange: boolean = true;

  // Flags de carga
  public downloading1 = false;
  public downloading2 = false;
  public downloading3 = false;

  // Permisos
  public repDetallado = false;
  public repOrganizacional = false;

  constructor(
    private reportsService: ReportsService, 
    private calendarServ: CalendarService, 
    private router: Router, 
    private settings: SettingsService,
    private globalService: GlobalFunctionsService,
    private adjustService: AdjustService,
    private datePipe: DatePipe
  ) { 
    this.maxDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd')!;
  }

  async ngOnInit() {
    this.userLogin = this.settings.getUser();
    this.globalService.canOperate();
    this.globalService.hasFSBRPending();

    // Validaciones iniciales de inventario y ajustes
    await this.checkInventoryStatus();
    
    // Configuración de permisos y tipos iniciales
    this.repDetallado = this.settings.getUserAccess().includes('CARRES');
    this.repOrganizacional = this.settings.getUserAccess().includes('CARORG');

    this.initType();
  }

  private async checkInventoryStatus() {
    try {
      const calendar = await this.calendarServ.CalendarInventoryInProgress().toPromise();
      if (calendar && calendar.length === 1) {
        this.globalService.messageToast('No es posible realizar esta operación, se encuentra en toma de inventario físico.', 'warning');
        this.router.navigate(['/home']);
        return;
      }

      const adjust = await this.adjustService.validateAdjustActive(this.userLogin.UnitId).toPromise();
      if (adjust && adjust.AdjustCode !== '') {
        this.globalService.messageToast('No es posible realizar esta operación, se encuentra en compulsa.', 'warning');
        this.router.navigate(['/home']);
      }
    } catch (error) {
      console.error('Error en validaciones iniciales', error);
    }
  }

  private initType() {
    if (this.userLogin.Org === 2) {
      this.type = 2;
      this.typeLevel = 'PLANTA';
    } else {
      this.type = 1;
      this.typeLevel = 'CEVE';
    }
  }

  cmbUnitChange(value: any) {
    this.typeLevel = (value == 2) ? 'PLANTA' : 'CEVE';
  }

  download(detalle: number) {
    if (!this.CalendarDesde || !this.CalendarHasta) {
      this.globalService.messageToast('Debe seleccionar un rango de fechas válido.', 'error');
      return;
    }

    this.setLoading(detalle, true);

    const unitType = (this.typeLevel === 'PLANTA') ? 2 : 1;

    this.reportsService.getRepCutExcel(unitType, this.CalendarDesde, this.CalendarHasta, detalle)
      .subscribe({
        next: (resp: any) => {
          this.processBlob(resp, unitType, detalle);
          this.setLoading(detalle, false);
        },
        error: (err) => {
          this.globalService.messageToast('Error al generar el reporte.', 'warning');
          this.setLoading(detalle, false);
          console.error(err);
        }
      });
  }

  private processBlob(resp: any, unitType: number, detalle: number) {
    const labels = { 1: 'Detallado', 2: 'Resumen', 3: 'Organizacional' };
    const prefix = (unitType === 1) ? 'CEVE' : 'FAB';
    const detaLabel = labels[detalle] || 'Reporte';

    const blob = new Blob([resp], { type: resp.type });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.download = `Reporte_Caratula_${prefix}_${detaLabel}.xlsx`;
    anchor.href = url;
    anchor.click();
    window.URL.revokeObjectURL(url);
  }

  private setLoading(id: number, state: boolean) {
    if (id === 1) this.downloading1 = state;
    if (id === 2) this.downloading2 = state;
    if (id === 3) this.downloading3 = state;
  }
}